const texts = {
    appName: 'Google Review List'
}

export default texts;
